var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,{tag:"component",attrs:{"type":_vm.type,"item":_vm.item},on:{"action-clicked":_vm.onActionClicked}})}
var staticRenderFns = []

export { render, staticRenderFns }